import React from 'react';
import { useSelector } from 'react-redux';

export default function ReturnOrderTableHeader({ numSelected, rowCount, onSelectAllClick }) {
    const wording = useSelector(({ language }) => language.wording);

    return (
        <thead>
            <tr>
                <th>
                    <input
                        type='checkbox'
                        className='input-checkbox'
                        checked={numSelected === rowCount}
                        onChange={onSelectAllClick}
                    />
                </th>
                <th className='product-name white' colSpan='2'>
                    {wording.usermenu.makeReturn.product}
                </th>
                <th className='product-quantity white'>{wording.usermenu.makeReturn.quantity}</th>
                <th className='refund-remark white'>{wording.usermenu.makeReturn.remark}</th>
            </tr>
        </thead>
    );
}
